<div class="comment-item" [class.reply]="!isTopLevel">
  <div class="avatar" [ngClass]="getAvatarColorClass(comment.authorName)">
    <img *ngIf="comment.authorAvatarUrl" [src]="comment.authorAvatarUrl" [alt]="comment.authorName" class="avatar__img" />
    <span *ngIf="!comment.authorAvatarUrl" class="avatar__initials">{{ getInitials(comment.authorName) }}</span>
  </div>

  <div class="comment-body">
    <div class="comment-bubble" *ngIf="!comment.isEditing">
      <div class="replying-to-tag" *ngIf="comment.replyingToAuthorName">
        <ptl-icon [icon]="LucideCornerDownRight" size="xs"></ptl-icon>
        <span
          >{{ 'translations.comments.actions.replyingTo' | transloco }} <strong>{{ comment.replyingToAuthorName }}</strong></span
        >
      </div>
      <div class="comment-meta">
        <span class="author-name">{{ comment.authorName }}</span>
        <span class="timestamp">{{ comment.updatedAt || comment.createdAt | folioCardTimeAgo }}</span>
      </div>
      <p class="comment-text">{{ comment.content }}</p>
    </div>

    <div class="comment-edit" *ngIf="comment.isEditing">
      <ptl-comment-input
        [momentId]="momentId"
        [placeholder]="'translations.comments.actions.editComment' | transloco"
        [initialValue]="comment.content"
        [isEditMode]="true"
        (commentUpdated)="onEditSaved($event)"
        (editCancelled)="cancelEdit()"
      ></ptl-comment-input>
    </div>

    <div class="comment-actions-bar">
      <div class="action-buttons">
        <button
          class="action-btn like-btn"
          [class.liked]="comment.likes.liked"
          (click)="onLikeToggle()"
          [disabled]="isLoading"
          [attr.aria-label]="'translations.global.button.like' | transloco"
        >
          <ptl-icon
            [icon]="LucideHeart"
            size="xs"
            [color]="comment.likes.liked ? 'var(--accent)' : undefined"
            [fill]="comment.likes.liked ? 'currentColor' : 'none'"
          ></ptl-icon>
        </button>

        <button
          class="action-btn reply-btn"
          (click)="startReply()"
          [disabled]="comment.isReplying"
          [attr.aria-label]="'translations.global.button.reply' | transloco"
        >
          <ptl-icon [icon]="LucideCornerDownLeft" size="xs"></ptl-icon>
        </button>

        <button
          class="action-btn edit-btn"
          (click)="startEdit()"
          *ngIf="isCurrentUserAuthor"
          [disabled]="comment.isEditing"
          [attr.aria-label]="'translations.global.button.edit' | transloco"
        >
          <ptl-icon [icon]="LucidePencil" size="xs"></ptl-icon>
        </button>

        <button
          class="action-btn delete-btn"
          (click)="onDelete()"
          *ngIf="isCurrentUserAuthor"
          [disabled]="isLoading"
          [attr.aria-label]="'translations.global.button.delete' | transloco"
        >
          <ptl-icon [icon]="LucideTrash2" size="xs"></ptl-icon>
        </button>
      </div>

      <button
        class="action-btn likes-count-btn"
        *ngIf="comment.likes.totalLikes > 0"
        (click)="showLikesDialog($event)"
        [attr.aria-label]="'translations.comments.actions.likesCount' | transloco: { count: comment.likes.totalLikes }"
      >
        <ptl-icon [icon]="LucideHeart" size="xs" color="var(--accent)"></ptl-icon>
        <span class="likes-count">{{ comment.likes.totalLikes }}</span>
      </button>
    </div>

    <div class="reply-input" *ngIf="comment.isReplying">
      <ptl-comment-input
        [momentId]="momentId"
        [placeholder]="'translations.comments.actions.replyTo' | transloco: { author: comment.authorName }"
        [parentCommentId]="comment.id"
        (commentCreated)="onReplyCreated($event)"
      ></ptl-comment-input>
    </div>

    <div class="replies-section" *ngIf="isTopLevel && comment.repliesCount > 0">
      <button class="expand-replies-btn" (click)="toggleReplies()" [class.expanded]="comment.isExpanded">
        <ptl-icon [icon]="comment.isExpanded ? LucideChevronUp : LucideChevronDown" size="xs"></ptl-icon>
        <span>
          {{
            comment.isExpanded
              ? ('translations.comments.actions.collapseReplies' | transloco: { count: totalRepliesCount })
              : ('translations.comments.actions.expandReplies' | transloco: { count: totalRepliesCount })
          }}
        </span>
      </button>

      <div class="replies-list" *ngIf="comment.isExpanded && comment.flatReplies && comment.flatReplies.length > 0">
        <div *ngFor="let reply of comment.flatReplies; trackBy: trackByReplyId">
          <ptl-comment-item
            [comment]="reply"
            [momentId]="momentId"
            [isTopLevel]="false"
            [currentUserId]="currentUserId"
            (commentUpdated)="commentUpdated.emit($event)"
            (commentDeleted)="commentDeleted.emit($event)"
            (commentLiked)="commentLiked.emit($event)"
            (replyCreated)="replyCreated.emit($event)"
          ></ptl-comment-item>
        </div>

        <div *ngIf="hasMoreReplies">
          <button class="expand-replies-btn" (click)="loadMoreReplies()" [disabled]="isLoadingReplies">
            <ptl-icon [icon]="LucideChevronDown" size="xs"></ptl-icon>
            <span>{{ 'translations.comments.actions.showMoreReplies' | transloco }}</span>
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
